import { useAuthorization } from "@auth/hooks/useAuthorization";
import { LoadingPage } from "@shared/pages/LoadingPage";
import { Outlet } from "react-router-dom"

export const AuthorizationLayout = () => {
    const { isLoadingAuthorization } = useAuthorization(); 

    if (isLoadingAuthorization) {
        return <LoadingPage />
    }
    return <Outlet/>
}